const DISMISSED_KEY = 'cruzcontrol_dismissed_announcements'

function loadDismissedIds() {
  try {
    const raw = localStorage.getItem(DISMISSED_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function saveDismissedIds(ids) {
  localStorage.setItem(DISMISSED_KEY, JSON.stringify(ids))
}

const state = {
  announcements: [],
  dismissedIds: loadDismissedIds()
}

const getters = {
  getAllAnnouncements: state => state.announcements,
  getVisibleAnnouncements: state => {
    const now = new Date()
    return state.announcements.filter(a => {
      if (!a.is_active) return false
      if (a.expires_at && new Date(a.expires_at) < now) return false
      if (state.dismissedIds.includes(a.id)) return false
      return true
    })
  },
  getDismissedIds: state => state.dismissedIds
}

const mutations = {
  setAnnouncements(state, announcements) {
    state.announcements = announcements || []
  },
  addAnnouncement(state, announcement) {
    // Avoid duplicates
    const exists = state.announcements.find(a => a.id === announcement.id)
    if (!exists) {
      state.announcements.unshift(announcement)
    }
  },
  updateAnnouncement(state, announcement) {
    const idx = state.announcements.findIndex(a => a.id === announcement.id)
    if (idx !== -1) {
      state.announcements.splice(idx, 1, announcement)
    } else {
      state.announcements.unshift(announcement)
    }
  },
  removeAnnouncement(state, announcementId) {
    state.announcements = state.announcements.filter(a => a.id !== announcementId)
  },
  dismissAnnouncement(state, announcementId) {
    if (!state.dismissedIds.includes(announcementId)) {
      state.dismissedIds.push(announcementId)
      saveDismissedIds(state.dismissedIds)
    }
  },
  clearDismissed(state) {
    state.dismissedIds = []
    saveDismissedIds([])
  }
}

export default {
  state,
  getters,
  mutations
}
